// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"a45023c1","387":"109bfb56","943":"fbdd318b"}[chunkId] + ".chunk.js";
};